import { render, staticRenderFns } from "./PromotionSignerInfoForm.vue?vue&type=template&id=8d4569f6"
import script from "./PromotionSignerInfoForm.vue?vue&type=script&lang=js"
export * from "./PromotionSignerInfoForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports